var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterDividerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "869px",
    height: "29px",
    viewBox: "0 0 869 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(49, 49, 49)",
    d: "M520.818,22.999 L516.036,28.328 L436.865,28.214 L446.813,16.938 L863.273,16.938 L868.824,23.230 L520.818,22.999 ZM492.539,14.122 L502.153,3.664 L506.668,3.716 L497.105,14.122 L492.539,14.122 ZM448.244,14.122 L457.859,3.664 L498.630,3.716 L489.067,14.122 L448.244,14.122 ZM413.994,0.342 L456.313,0.342 L434.344,25.411 L413.994,0.342 ZM379.933,14.122 L371.158,3.716 L412.718,3.664 L421.544,14.122 L379.933,14.122 ZM372.051,14.122 L363.277,3.716 L367.791,3.664 L376.618,14.122 L372.051,14.122 ZM432.135,28.214 L352.964,28.328 L348.182,22.999 L0.176,23.230 L5.727,16.938 L422.187,16.938 L432.135,28.214 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterDividerGray);
export default __webpack_public_path__ + "static/media/center_divider_gray.b4ec04838057c93667ff93862c9ea4af.svg";
export { ForwardRef as ReactComponent };